"use strict";

exports.__esModule = true;
exports.APP_LOCATION_URL = exports.DEFAULT_COUNTRY = void 0;
var DEFAULT_COUNTRY = 'us';
exports.DEFAULT_COUNTRY = DEFAULT_COUNTRY;
var APP_LOCATION_URL = 'https://app-location.pipefy.com/json/';
exports.APP_LOCATION_URL = APP_LOCATION_URL;